module.exports = __webpack_public_path__ + "b4e0045784568bc212a3bb6de08891ff.ttf";